import React from 'react';
import Relatorio from '../components/Relatorio';

const LandingPage = () => {
  return (
    <Relatorio />
  );
};

export default LandingPage;
